<!-- 基础开发管理平台 部局首页 -->
<template>
  <el-container>
    <el-main>
      <basic-container class="table_div">
        <div
          class="
            width-p100
            bb-sm-primary
            mb-xxs
            ds-fx
            flex-direction-row
            justify-content-start
            align-items-center
          "
        >
          <i class="el-icon-document color-primary mr-sm"></i>
          <el-badge
            :value="page.total"
            :max="99"
            class="item"
            :hidden="page.total ? false : true"
          >
            <el-button type="text">待批事项</el-button>
          </el-badge>
        </div>
        <div>
          <avue-crud :option="option" :data="tableData">
            <template slot="empty">
              <div desc="无数据"></div>
            </template>
            <template slot="SERVER_NAME" slot-scope="{ row }">
              <el-button type="text" size="mini" v-text="row.SERVER_NAME" @click="dpClick(row)"></el-button>
            </template>
            <template slot="COUNT_NUMBER" slot-scope="{ row }">
              <el-button type="text" size="mini" v-text="row.COUNT_NUMBER" @click="dpClick(row)"></el-button>
            </template>
          </avue-crud>
          <div class="block">
            <p
              v-text="
                `总数${page.total}，共${page.pages}页，当前为第${page.currentPage}页，每页${page.pageSize}条`
              "
            ></p>
            <el-pagination
              @current-change="needCurrentChange"
              @size-change="needSizeChange"
              :current-page="page.currentPage"
              :page-sizes="[5, 10, 20, 50, 100, 200, 500, 1000]"
              :page-size="page.pageSize"
              layout="total,sizes, prev, pager, next, jumper"
              :total="page.total"
            >
            </el-pagination>
          </div>
        </div>
      </basic-container>
      <basic-container class="table_div">
        <div
          class="
            width-p100
            bb-sm-primary
            mb-xxs
            ds-fx
            flex-direction-row
            justify-content-start
            align-items-center
          "
        >
          <i class="el-icon-document color-primary mr-sm"></i>
          <el-badge
            :value="methodPage.total"
            :max="99"
            class="item"
            :hidden="methodPage.total ? false : true"
          >
            <el-button type="text">工作提醒</el-button>
          </el-badge>
        </div>
        <div>
          <avue-crud :option="option1" :data="tableData1">
            <template slot="empty">
              <div desc="无数据"></div>
            </template>
            <template slot="SERVER_NAME" slot-scope="{ row }">
              <el-button type="text" size="mini" v-text="row.SERVER_NAME" @click="dpClick(row)"></el-button>
            </template>
            <template slot="COUNT_NUMBER" slot-scope="{ row }">
              <el-button type="text" size="mini" v-text="row.COUNT_NUMBER" @click="dpClick(row)"></el-button>
            </template>
          </avue-crud>
          <div class="block">
            <p
              v-text="
                `总数${methodPage.total}，共${methodPage.pages}页，当前为第${methodPage.currentPage}页，每页${methodPage.pageSize}条`
              "
            ></p>
            <el-pagination
              @current-change="methodCurrentChange"
              @size-change="methodSizetChange"
              :current-page="methodPage.currentPage"
              :page-sizes="[5, 10, 20, 50, 100, 200, 500, 1000]"
              :page-size="methodPage.pageSize"
              layout="total,sizes, prev, pager, next, jumper"
              :total="methodPage.total"
            >
            </el-pagination>
          </div>
        </div>
      </basic-container>
      <basic-container class="table_div">
        <div
          class="
            width-p100
            bb-sm-primary
            mb-xxs
            ds-fx
            flex-direction-row
            justify-content-start
            align-items-center
          "
        >
          <i class="el-icon-document color-primary mr-sm"></i>
          <el-badge
            :value="unfinishedPage.total"
            :max="99"
            class="item"
            :hidden="unfinishedPage.total ? false : true"
          >
            <el-button type="text">本人未结任务</el-button>
          </el-badge>
        </div>
        <div>
          <avue-crud
            :option="optionRW"
            :data="tableDataRW"
          >
            <template slot="SERVER_NAME" slot-scope="{ row }">
              <el-button type="text" size="mini" v-text="row.SERVER_NAME" @click="dpClick(row)"></el-button>
            </template>
            <template slot="COUNT_NUMBER" slot-scope="{ row }">
              <el-button type="text" size="mini" v-text="row.COUNT_NUMBER" @click="dpClick(row)"></el-button>
            </template>
          </avue-crud>
          <div class="block">
            <span
              v-text="
                `总数${unfinishedPage.total}，共${unfinishedPage.pages}页，当前为第${unfinishedPage.currentPage}页，每页${unfinishedPage.pageSize}条`
              "
            ></span>
            <el-pagination
              @current-change="handleRWCurrentChange"
              @size-change="handleRWSizeChange"
              :current-page="unfinishedPage.currentPage"
              :page-size="unfinishedPage.pageSize"
              :page-sizes="[5, 10, 20, 50, 100, 200, 500, 1000]"
              layout="total,sizes, prev, pager, next, jumper"
              :total="unfinishedPage.total"
            >
            </el-pagination>
          </div>
        </div>
      </basic-container>
    </el-main>
    <el-aside width="240px" height="100%">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span><i class="el-icon-s-promotion"></i>快捷方式</span>
        </div>
        <div
          class="pUserShortcut"
          v-for="(item, index) in pUserShortcutData"
          :key="index"
          @click="pUserShortcutClick(item.opId, item.opName,item)"
        >
          <svg class="icon svg-icon" aria-hidden="true" style="font-size: 18px">
            <use :xlink:href="item.source"></use>
          </svg>{{ item.opName }}
        </div>
        <div class="pUserShortcutClear"></div>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span><i class="el-icon-question"></i>帮助</span>
          <el-button style="float: right; padding: 3px 0" type="text" @click="gotoHelpPage">更多>></el-button>
        </div>
        <div>
          <p>
            <el-button type="text" @click="openUrl(1)"
              >一、配置步骤；</el-button
            >
          </p>
          <p>
            <el-button type="text" @click="openUrl(2)"
              >二、系统管理员手册；</el-button
            >
          </p>
          <p>
            <el-button type="text" @click="openUrl(3)"
              >三、系统用户手册；</el-button
            >
          </p>
          <p>
            <el-button type="text" @click="openUrl(4)"
              >四、绘图软件；</el-button
            >
          </p>
        </div>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span><i class="el-icon-question"></i>注意事项</span>
        </div>
        <div class="color-theadC fs-mm">
          <p class="my-xxs">1. 文书打印预览需要安装打印控件；</p>
          <p class="my-xxs">2. 文书文号、抬头不符：请到系统管理→执法单位中设置；</p>
          <p class="my-xxs">3. 更换承办人：请到系统管理→换承办人更换。</p>
        </div>
      </el-card>
    </el-aside>
  </el-container>
</template>

<script>
import { getDataByDataId,post } from "@/api/table/table";
import { pUserShortcut } from "@/api/home/home";
import { mapGetters } from "vuex";
import { getList,saveOpRunLog } from "@/api/system/public";
import { filterArr } from "@/util/util";
import { getDictionary } from "@/api/system/dict";
import {parseParams} from '@/util/util';
export default {
  components: {},
  data() {
    //这里存放数据
    return {
      Alltable:[],//本人未结任务数据--克隆
      tableData: [], // 待办数据
      tableData1: [], // 提醒事项数据
      tableDataRW: [], // 本人未结任务数据
      pUserShortcutData: [], // 快捷方式数据
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1,
        pages: 0
      },
      methodPage: {
        pageSize: 5,
        total: 0,
        currentPage: 1,
        pages: 0
      },
      unfinishedPage: {
        pageSize: 10,
        total: 0,
        currentPage: 1,
        pages: 0
      },
      option: {
        menu: false, // 菜单
        border: true,
        menuWidth: 120,
        align: "center", // 居中
        header: false,
        stripe: true,
        editBtn: false,
        delBtn: false,
        column: [
          {
            prop: "SERVER_NAME",
            label: "单位名称",
            slot:true,
          },
          {
            prop: "COUNT_NUMBER",
            label: "消息数量",
            slot:true,
            width: 88,
          },
        ]
      },
      option1: {
        align: "center",
        border: true,
        header: false,
        overHidden: true,
        menuWidth: 90,
        stripe: true,
        menu: false,
        column: [
          {
            prop: "SERVER_NAME",
            label: "单位名称",
            slot:true,
          },
          {
            prop: "COUNT_NUMBER",
            label: "消息数量",
            slot:true,
            width: 88,
          },
        ]
      },
      optionRW:{
        align: "center",
        border: true,
        header: false,
        menu: false,
        editBtn: false,
        delBtn: false,
        stripe: true,
        column: [
          {
            prop: "SERVER_NAME",
            label: "单位名称",
            slot:true,
          },
          {
            prop: "COUNT_NUMBER",
            label: "消息数量",
            slot:true,
            width: 88,
          },
        ]
      },
      tabName: "all", //点击的tab
    };
  },
  //监听属性 类似于data概念
  computed: { ...mapGetters(["userInfo", "setIp"]) },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 待办行按钮点击
    handleDB(btn, row) {
      console.log(btn, row);
      switch (btn.BUTTON_TYPE) {
        case "divideWork": // 分工
          this.$router.push({
            path: "/xfjd/sendDivision",
            query: {
              runId: this.userInfo.runId,
              lzid: row.LZID,
              parentName: "首页",
              path: this.$route.path
            }
          });
          break;
        default:
          // 其他
          this.$router.push({
            path: "/xfjd/approval",
            query: {
              runId: this.userInfo.runId,
              lzid: row.LZID,
              parentName: "首页",
              path: this.$route.path
            }
          });
          break;
      }
    },
    // 初次加载所有
    onLoad() {
      this.onLoadNeed();
      this.onLoadMethod();
      this.onLoadShortcut();
      this.onLoadRW();
    },
    // 跳转帮助页面
    gotoHelpPage() {
      this.$router.push({
        path: "/system/helpView",
        query: {
          runId: this.userInfo.runId,
        },
      });
    },
    // 数组渲染
    findArr(arr, key, value, re) {
      return filterArr(arr, key, value, re);
    },
    // 加载待办
    onLoadNeed() {
      post("/api/blade-xfjd/api/buju/firstPageDpsx",this.$qs.stringify({
        current:this.page.currentPage,
        size:this.page.pageSize,
      })).then(res => {
        let data = res.data.data;
        if(data){
          this.tableData = data.records;
          this.page = {
            pageSize: data.size || 10,
            total: data.total || 0,
            currentPage: data.current || 1,
            pages: data.pages || 0
          };
        }
      });
    },
    // 加载提醒事项
    onLoadMethod() {
      post("/api/blade-xfjd/api/buju/firstPageGztx",this.$qs.stringify({
        current:this.methodPage.currentPage,
        size:this.methodPage.pageSize,
      })).then(res => {
        let data = res.data.data;
        if(data){
          this.tableData1 = data.records;
          this.methodPage = {
            pageSize: data.size || 5,
            total: data.total || 0,
            currentPage: data.current || 1,
            pages: data.pages || 0
          };
        }
      });
    },
    // 加载快捷方式
    onLoadShortcut() {
      pUserShortcut(
        this.$qs.stringify({
          count:'10'
        })
      ).then(
        res => {
          this.loading = false;
          this.pUserShortcutData = res.data.data;
        },
        e => {
          this.loading = false;
        }
      );
    },
    //加载本人未结任务
    onLoadRW() {
      console.log("本人未结");
      post("/api/blade-xfjd/api/buju/firstPageBrwjrw",this.$qs.stringify({
        current:this.unfinishedPage.currentPage,
        size:this.unfinishedPage.pageSize,
      })).then(res => {
        const data = res.data.data;
        if(data){
          this.tableDataRW = data.records;
          this.unfinishedPage = {
            pageSize: data.size || 10,
            total: data.total || 0,
            currentPage: data.current || 1,
            pages: data.pages || 0
          };
        }
      });
    },
    // 待办翻页
    needCurrentChange(val) {
      this.page.currentPage = val;
      this.onLoadNeed();
    },
    // 待办翻页
    needSizeChange(val) {
      this.page.pageSize = val;
      this.onLoadNeed();
    },
    // 提醒事项翻页
    methodCurrentChange(val) {
      this.methodPage.currentPage = val;
      this.onLoadMethod();
    },
    // 提醒事项翻页
    methodSizetChange(val) {
      this.methodPage.pageSize = val;
      this.onLoadMethod();
    },
    //本人未结任务翻页
    handleRWCurrentChange(val) {
      this.unfinishedPage.currentPage = val;
      this.onLoadRW();
    },
    //本人未结任务翻页
    handleRWSizeChange(val) {
      this.unfinishedPage.pageSize = val;
      this.onLoadRW();
    },
    // 快捷方式点击
    pUserShortcutClick(opId, name,item) {
      console.log(item);
      this.loading = true;
      getList({ opid: opId, folderId: "null" }).then(
        res => {
          const data = res.data.data;
          if (data.opsEntities.length == 1) {
            if(item.authPage==1){
              this.$router.replace({
                path: "/system/deploy",
                query: {
                  runId:data.opsEntities[0].runId,
                  name:item.name,
                  path:data.opsEntities[0].path,
                  // ...obj,
                },
              });
              return;
            }else if(item.authPage==2){
              this.$router.replace({
                path: item.path+"BJ",
                query: {
                  runId:data.opsEntities[0].runId,
                  name:item.name,
                  path:data.opsEntities[0].path,
                  // ...obj,
                },
              });
              return;
            }
            this.$router.replace({
              path: data.opsEntities[0].path,
              query: {
                runId: data.opsEntities[0].runId,
                name: name
              }
            });
            this.loading = false;
          } else {
            this.loading = false;
            this.$router.replace({
              path: this.$router.$avueRouter.getPath({
                name: name,
                src: `/system/public${opId}&null&${name}`
              })
            });
          }
        },
        err => {
          this.loading = false;
        }
      );
    },
    // 点击帮助
    openUrl(num) {
      switch (num) {
        case 1:
          window.open(this.setIp.xfjdpreviewfileip+"?md5=aHR0cDovLzE5Mi4xNjguMS4yNDk6OTAwMC94ZmpkL3VwbG9hZC9kb2MvMjAyMTExMTUvZjAwMWFkMzdjYjZlYzliZTNjZTg5M2YzYWE0ZGVmMjYuZG9jPXVwbG9hZC9kb2MvMjAyMTExMTUvZjAwMWFkMzdjYjZlYzliZTNjZTg5M2YzYWE0ZGVmMjYuZG9jPdDCsObP-7fAvOC2vbncwO3Ptc2z08O7p8rWsuE9ZG9j&officePreviewType=pdf");
          break;
        case 2:
          window.open(this.setIp.xfjdpreviewfileip+"?md5=aHR0cDovLzE5Mi4xNjguMS4yNDk6OTAwMC94ZmpkL3VwbG9hZC9kb2MvMjAyMTExMTUvZWQ3YTQ3NjYwODg2MDhmYWU3NzIwNTU1YjdjZWNhNzMuZG9jPXVwbG9hZC9kb2MvMjAyMTExMTUvZWQ3YTQ3NjYwODg2MDhmYWU3NzIwNTU1YjdjZWNhNzMuZG9jPdDCsObP-7fAvOC2vbncwO3Ptc2zudzA7dSxytay4T1kb2M&officePreviewType=pdf");
          break;
        case 3:
          // 传入参数以逗号分隔开 发案地址,发案时间,绘制单位,绘图人,被害人(复数，以“、”分割),案件类别(符合国标类别)
          // 案件类别为非必填项，其余选项为必填项
          window.location.href = "openIE:file:///C:/TYSoft/mh.html?cs=广东省,2021-05-13,广州支队,李警官,张三,hhh";
          break;
        default:
          break;
      }
    },
    toPage(row){
      if(row.RWID){
        this.$router.push({
          path: row.RWZLX==5?"/xfjd/hzdc/fireDetail":"/xfjd/projectDetail",
          query: {
            runId: this.userInfo.runId,
            RWID: row.RWID,
            path: this.$route.path,
            pagetype:1,  // 1 办理 , 2  是查看
            parentName: "首页",
          },
        });
      }else{
        this.$message.warning("任务ID不存在!")
      }
    },
    // 待批事项点击名称  跳到别的系统
    dpClick(row){
      let url = parseParams(row.SERVER_URL+'/#/login?',{type:"1",path:"/wel/index",user:this.userInfo.user_acc});
      console.log(url);
      window.open(url, '_blank');
    },
  },
  created() {
    this.onLoad();
  },
  mounted() {},
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
/deep/ .avue-crud__pagination {
  display: none;
}
.block {
  overflow: hidden;
  p {
    float: left;
    font-size: 13px;
    color: #606266;
    padding-left: 10px;
  }
  /deep/ .el-pagination {
    float: right;
  }
  span {
    font-size: 13px;
    color: #606266;
    padding-left: 10px;
  }
}
/deep/ .el-table__row td {
  padding: 0;
}
.pUserShortcut {
  width: 164px;
  float: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  i {
    margin-right: 4px;
  }
}
.box-card {
  margin-top: 10px;
  /deep/.el-card__body {
    overflow: hidden;
  }
}
.table_div {
  padding-bottom: 0;
  /deep/ .el-card__body {
    padding: 10px !important;
    padding-bottom: 0 !important;
  }
  /deep/td,
  /deep/th,
  /deep/.cell {
    padding: 0 !important;
  }
  /deep/.el-tabs__header {
    margin: 0 auto;
    width:99%;
    .is-top > span,
    .is-top > .el-tabs__nav-scroll > .el-tabs__nav > div {
      line-height: 24px;
      height: 24px;
    }
  }
}
/deep/.item .el-button {
  padding: 0px !important;
  font-size: 16px !important;
  color: #303133 !important;
}
/deep/.item .el-badge__content {
  background-color: #f51b1b;
}
/deep/.el-badge__content.is-fixed {
  top: 11px !important;
  right: -1px !important;
}
/deep/.el-aside .el-card__body{
  padding: 10px !important;
}
</style>
